import { FormControl } from '@angular/forms';

import { isEmpty } from '@recruitee/utils';

import { URL_PATTERN } from './url-validator';

export function potentialUrlValidator(control: FormControl): { url: boolean } | null {
  const trimmed = control.value ? control.value.replace(/(^\s+)|(\s+$)/g, '') : null;

  return isEmpty(trimmed) || URL_PATTERN.test(trimmed) ? null : { url: true };
}
